/*
 * Endless scrolling for the results grid.
 *
 * Progressive, not replacing: the markup ships as an ordinary paginated
 * collection with a real link to page two and the full pager under it. This
 * takes that link over. With no JavaScript, or before this arrives, or if a
 * fetch fails, the shopper still has a working collection.
 *
 * Three things it is careful about:
 *
 *   The footer. Auto-loading forever means a footer nobody can reach, so it
 *   auto-loads a few pages and then waits to be asked. The button was always
 *   there; it just stops being pressed for you.
 *
 *   The address bar. Each page that lands writes itself into the URL, so a
 *   reload or a shared link comes back to roughly where the shopper was
 *   instead of to the top of page one.
 *
 *   Saying so. Appending silently is invisible to a screen reader, so each
 *   load announces what arrived through a live region.
 */
(function () {
  'use strict';

  var AUTO_PAGES = 3;      // then the shopper asks
  var ROOT_MARGIN = '600px'; // start fetching before the seam is on screen

  function parseGrid(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return {
      cards: doc.querySelectorAll('.az-grid > li'),
      more: doc.querySelector('[data-az-more]'),
      pager: doc.querySelector('[data-az-more-pager]'),
    };
  }

  function init() {
    var box = document.querySelector('[data-az-more]');
    var grid = document.querySelector('.az-grid');
    if (!box || !grid) return;

    var btn = box.querySelector('[data-az-more-btn]');
    var status = box.querySelector('[data-az-more-status]');
    var pager = document.querySelector('[data-az-more-pager]');
    var next = box.getAttribute('data-az-next');
    if (!next || !btn) return;

    // The pager is the no-JS path. Once this is running it is a duplicate of
    // the button, so it goes; it comes back if a fetch fails.
    if (pager) pager.hidden = true;

    var loading = false;
    var autoLeft = AUTO_PAGES;

    // Products only. The app tile is a cell in the grid but it is not one of
    // the things being counted, and counting it reported 21 of 30 after two
    // pages of ten.
    function counted() {
      return grid.querySelectorAll('li:not(.az-card--slot)').length;
    }

    function say(msg) {
      if (status) status.textContent = msg;
    }

    function stop() {
      box.hidden = true;
      if (pager) pager.hidden = true;
    }

    function fail() {
      // Hand it back to the pager rather than leaving a dead button.
      if (pager) pager.hidden = false;
      btn.hidden = true;
      say('');
    }

    function load() {
      if (loading || !next) return;
      loading = true;
      btn.setAttribute('aria-busy', 'true');
      say('Loading more');

      var url = next;
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var got = parseGrid(html);
          if (!got.cards.length) { stop(); return; }

          var frag = document.createDocumentFragment();
          Array.prototype.forEach.call(got.cards, function (li) {
            // The app tile belongs to page one only; it is already on the page.
            if (li.classList.contains('az-card--slot')) return;
            frag.appendChild(document.importNode(li, true));
          });
          grid.appendChild(frag);

          var loaded = counted();
          var total = parseInt(box.getAttribute('data-az-total'), 10) || 0;
          say(total ? 'Showing ' + loaded + ' of ' + total : loaded + ' loaded');

          try { window.history.replaceState({}, '', url); } catch (e) { /* not fatal */ }

          next = got.more ? got.more.getAttribute('data-az-next') : null;
          if (next) {
            box.setAttribute('data-az-next', next);
            btn.setAttribute('href', next);
          } else {
            btn.hidden = true;
            say(total ? 'Showing all ' + total : '');
          }
        })
        .catch(fail)
        .then(function () {
          loading = false;
          btn.removeAttribute('aria-busy');
        });
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      autoLeft = AUTO_PAGES; // asking for one buys a few more automatic ones
      load();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        if (autoLeft <= 0 || loading || !next) return;
        autoLeft -= 1;
        load();
      }, { rootMargin: ROOT_MARGIN }).observe(box);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
